import { useState } from "react";
import { IoCloseOutline, IoCloudUploadSharp } from "react-icons/io5";
import * as D from "assets/iconsSVG/documentIcon";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useAnexarLaudo } from "services/api/AppWeb_Oportunidade/put-anexar-laudo";
import * as MaterialUI from "@material-ui/core";
import * as S from "./styles";

interface Data {
  onClose: () => void;
  dataDetalheOportunidade: any;
  refetchDetalheOportunidade: () => void;
  refetchHistorico: () => void;
}

const ModalAnexarLaudoVivaz = (data: Data) => {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  const { mutate: mutateAnexarLaudo, isLoading: isLoadingAnexarLaudo } =
    useAnexarLaudo();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setUploadedFile(e.target.files[0]);
    }
  };

  const handleSendFile = () => {
    if (uploadedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target?.result;
        mutateAnexarLaudo(
          {
            idOportunidade: data.dataDetalheOportunidade?.idOportunidade,
            extensaoArquivo: uploadedFile.name.split(".").pop() as string,
            base64: (base64 as string).split(",").pop() as string,
          },
          {
            onSuccess: () => {
              data.refetchDetalheOportunidade();
              data.refetchHistorico();
              data.onClose();
            },
          }
        );
      };
      reader.readAsDataURL(uploadedFile);
    }
  };

  const handleRemoveFile = () => {
    setUploadedFile(null);
  };

  return (
    <S.Content>
      <S.Header>
        <S.Row style={{ justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <D.DocumentIcon />
            <S.TextTitle>Upload de Documentos</S.TextTitle>
          </div>
          <S.CloseButton onClick={data.onClose}>
            <IoCloseOutline size={32} />
          </S.CloseButton>
        </S.Row>
      </S.Header>
      <S.SpaceY space={8} />
      <S.Body>
        {!uploadedFile ? (
          <label htmlFor="file-upload">
            <S.ContentRowCutted>
              <IoCloudUploadSharp size={24} color="#999999" />
              <S.TextDescription>
                {data.dataDetalheOportunidade.urlLaudoCredito !== null
                  ? "Carregar novo Anexo"
                  : "Carregar Anexo"}
              </S.TextDescription>
            </S.ContentRowCutted>
            <input
              id="file-upload"
              type="file"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </label>
        ) : (
          <>
            <S.ContentDocument>
              <S.TextUpload>Documento</S.TextUpload>
            </S.ContentDocument>
            <S.SpaceY space={8} />
            <S.ContentInfoDocument>
              <S.TextUpload>{uploadedFile.name}</S.TextUpload>
              <S.DeleteButton onClick={handleRemoveFile}>
                <RiDeleteBin6Line size={24} color="#ff4d4f" />
              </S.DeleteButton>
            </S.ContentInfoDocument>
            <S.SpaceY space={8} />
            <S.ContentRowCuttedNoAction>
              <IoCloudUploadSharp size={24} color="#999999" />
              <S.TextDescription>Você já carregou um anexo</S.TextDescription>
            </S.ContentRowCuttedNoAction>
          </>
        )}
        <S.SpaceY space={32} />
        <S.SaveButton
          onClick={() => {
            handleSendFile();
          }}
          disabled={!uploadedFile || isLoadingAnexarLaudo}
        >
          {isLoadingAnexarLaudo ? (
            <MaterialUI.CircularProgress
              size={22}
              style={{ color: "#ffffff" }}
            />
          ) : (
            "Enviar"
          )}
        </S.SaveButton>
      </S.Body>
    </S.Content>
  );
};

export default ModalAnexarLaudoVivaz;
